import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/pages/home/index';
import Login from '@/pages/my/login';
import Book from '@/pages/book/index';
import Bookdetail from '@/pages/book/detail';
import My from '@/pages/my/index';
import Wall from '@/pages/wall/index';
import WallDetail from '@/pages/wall/detail';
import Search from '@/pages/home/search';
import Pic from '@/pages/pic/index';
import Picdetail from '@/pages/pic/detail';
import Teximg from '@/pages/teximg/index';
import Teximgdetail from '@/pages/teximg/detail';
import Register from '@/pages/my/register';
import Video from '@/pages/video/index';
import Videodetail from '@/pages/video/detail';
import Audit from '@/pages/audit/index';
import Auditdetail from '@/pages/audit/detail';
import HomeDetail from '@/pages/home/detail';
import PDF from '@/pages/pdf/index';


Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/pdf/index',
            name: 'PDF',
            component: PDF
        },
        {
            path: '/my/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/book/index',
            name: 'Book',
            component: Book
        },
        {
            path: '/book/detail',
            name: 'Bookdetail',
            component: Bookdetail
        },
        {
            path: '/my/index',
            name: 'My',
            component: My
        },
        {
            path: '/wall/index',
            name: 'Wall',
            component: Wall
        },
        {
            path: '/wall/detail',
            name: 'WallDetail',
            component: WallDetail
        },
        {
            path: '/home/search',
            name: 'Search',
            component: Search
        },
        {
            path: '/pic/index',
            name: 'Pic',
            component: Pic
        },
        {
            path: '/pic/detail',
            name: 'Picdetail',
            component: Picdetail
        },
        {
            path: '/teximg/index',
            name: 'Teximg',
            component: Teximg
        },
        {
            path: '/teximg/detail',
            name: 'Teximgdetail',
            component: Teximgdetail
        },
        {
            path: '/my/register',
            name: 'Register',
            component: Register
        },
        {
            path: '/video/index',
            name: 'Video',
            component: Video
        },
        {
            path: '/video/detail',
            name: 'Videodetail',
            component: Videodetail
        },
        {
            path: '/audit/index',
            name: 'Audit',
            component: Audit
        },
        {
            path: '/audit/detail',
            name: 'Auditdetail',
            component: Auditdetail
        },
        {
            path: '/home/detail',
            name: 'HomeDetail',
            component: HomeDetail
        },
    ],
    mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js